/* 🤖 this file was generated by svg-to-ts*/
export const iconMale: {
  name: 'male';
  data: string;
} = {
  name: 'male',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M8.829 12.828c-1.512 1.512-4.146 1.512-5.657 0A3.973 3.973 0 012 10c0-1.068.416-2.072 1.172-2.828A3.973 3.973 0 016 6c1.069 0 2.073.416 2.829 1.172A3.976 3.976 0 019.999 10a3.976 3.976 0 01-1.17 2.828M13.999 0h-4a1 1 0 100 2h2.587L9.473 5.113A5.948 5.948 0 006 4a5.957 5.957 0 00-4.242 1.758A5.956 5.956 0 000 10c0 1.602.624 3.11 1.758 4.242A5.957 5.957 0 006 16c1.603 0 3.11-.624 4.243-1.758A5.96 5.96 0 0012 10a5.948 5.948 0 00-1.113-3.473L14 3.414V6a1 1 0 102 0V2c0-1.103-.897-2-2-2"/></svg>`,
};
